//these are some config values for the webapp that get used in multiple compenents

import { IPandasFilterItemV2, IPandasFilterV2 } from '@interfaces';
import { getTimeZones } from '@vvo/tzdb';
export const defaultPandasFilterItemV2: IPandasFilterItemV2 = {
  index: 0,
  column: null,
  comparison: '=',
  not_: false,
  value: null,
  useAdvanced: false,
  logicOperator: 'and',
  advancedValue: { valueType: null },
};

export const defaultPandasFilterV2: IPandasFilterV2 = {
  parentheses: { leftParentheses: [[]], rightParentheses: [[]] },
  items: [defaultPandasFilterItemV2],
};

export var defaultColumnOperation = {
  leftParentheses: [[]],
  rightParentheses: [[]],
  logicOperators: [],
  column_name: '',
  useGrouping: false,
  grouping: {
    groupingKey: null,
    groupingType: 'first_match',
    filter: undefined,
  },
  filter: [
    {
      index: 0,
      type: 'column',
      valid: '#ff3d71',
      column: '',
      useOffset: false,
      timezone: 'UTC',
    },
  ],
  type: null,
};
//{ left_parentheses: [[]], right_parentheses: [[]], logic_operators: [], dtype: 'float', filter: [{ index: 0, valid: 'red', column: '',  use_offset: false }] }
const timeIncrements = [
  'nanoseconds',
  'milliseconds',
  'seconds',
  'minutes',
  'hours',
  'days',
  'weeks',
];

const dateNumberConversions = [
  'quarter of year',
  'month of year',
  'week of year',
  'week of quarter',
  'week of month',
  'day of year',
  'day of quarter',
  'day of month',
  'day of week',
];
const datetimeNumberConversions = [
  ...dateNumberConversions,
  'hour of day',
  'minute of hour',
  'second of minute',
];
export var datatype_conversions = {
  boolean: {
    to_types: ['string', 'int'],
    int: null,
    string: null,
    allowed_operators: {
      float: ['+', '-', 'x', '÷', '^'],
      int: ['+', '-', 'x', '÷', '^'],
      boolean: ['+', '-', 'x', '÷', '^'],
      string: [],
      timedelta: ['x'],
      datetime: [],
      date: [],
    },
  },
  float: {
    to_types: ['int', 'boolean', 'string', 'timedelta', 'datetime', 'date'],
    int: null,
    boolean: null,
    string: null,
    datetime: timeIncrements,
    date: timeIncrements,
    timedelta: timeIncrements,

    allowed_operators: {
      float: ['+', '-', 'x', '÷', '^'],
      int: ['+', '-', 'x', '÷', '^'],
      boolean: ['+', '-', 'x', '÷', '^'],
      string: [],
      timedelta: ['x', '÷'],
      datetime: [],
      date: [],
    },
  },
  int: {
    to_types: ['float', 'boolean', 'string', 'timedelta', 'datetime', 'date'],
    float: null,
    boolean: null,
    string: null,
    datetime: timeIncrements,
    date: timeIncrements,
    timedelta: timeIncrements,
    allowed_operators: {
      float: ['+', '-', 'x', '÷', '^'],
      int: ['+', '-', 'x', '÷', '^'],
      boolean: ['+', '-', 'x', '÷', '^'],
      string: [],
      timedelta: ['x', '÷'],
      datetime: [],
      date: [],
    },
  },
  string: {
    to_types: ['int', 'float', 'boolean', 'timedelta', 'datetime', 'date'],
    int: null,
    float: null,
    boolean: null,
    timedelta: null,
    datetime: null,
    date: null,
    allowed_operators: {
      float: [],
      int: [],
      boolean: [],
      string: ['+'],
      timedelta: [],
      datetime: [],
      date: [],
    },
  },
  timedelta: {
    to_types: ['int', 'float', 'string'],
    int: timeIncrements,
    float: timeIncrements,
    string: null,
    allowed_operators: {
      float: ['x', '÷'],
      int: ['x', '÷'],
      boolean: ['x'],
      string: [],
      timedelta: ['+', '-'],
      datetime: ['+'],
      date: ['+'],
    },
  },
  datetime: {
    to_types: ['int', 'float', 'string', 'date', 'timedelta'],
    int: datetimeNumberConversions,
    float: datetimeNumberConversions,
    timedelta: [
      'time of day',
      'hour of day',
      'minute of hour',
      'second of minute',
    ],
    string: [
      'None',
      'weekday',
      'month',
      'year',
      'month/year',
      'month/day',
      'month/day/year',
      'year/month/day',
      'day/month/year',
      'hour/minute/second',
      'hour/minute',
    ],
    date: null,
    allowed_operators: {
      float: [],
      int: [],
      boolean: [],
      string: [],
      timedelta: ['+', '-'],
      datetime: ['-'],
      date: ['-'],
    },
  },
  date: {
    to_types: ['int', 'float', 'string', 'datetime'],
    int: dateNumberConversions,
    float: dateNumberConversions,
    string: [
      'None',
      'weekday',
      'month',
      'year',
      'month/year',
      'month/day/year',
      'day/month/year',
    ],
    datetime: null,
    allowed_operators: {
      float: [],
      int: [],
      boolean: [],
      string: [],
      timedelta: ['+', '-'],
      datetime: ['-'],
      date: ['-'],
    },
  },
};

export const notificationRoutes: {
  [key: string]: { url: string; param: string; routeParam: boolean };
} = {
  // 'Broken Widget': { url: '/dash-v2', param: null, routeParam: false },
  // http://localhost:4200/data-streams?dataStreamType=table&dataStreamId=2015f187-e13e-4223-a368-b9b02f8b19cb&engineType=join-tables&sourceUuid=join-tables
  // 'Broken Joined Dataset': { url: 'data-streams?&dataStreamId=', param: null, routeParam: false },
  // 'Broken Integration Connection': {
  //   url: '/data-management/integrations/add-integration/',
  //   param: null,
  //   routeParam: true,
  // },
  // 'Broken Modified Dataset': {
  //   url: '/data-management/modified-datasets',
  //   param: null,
  //   routeParam: false,
  // },
};

export const timezoneNames = () => {
  return getTimeZones().map((tz) => tz.name);
};

export var extra_cols = ['_transactioncurrencyid_value'];
